import { useContext, createContext } from 'react'

export const FeatureFormContext = createContext(null)

export const useFeatureFormContext = () => {
  return useContext(FeatureFormContext)
}
